import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function Terms() {
  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4">
      <div className="max-w-3xl mx-auto bg-white rounded-xl shadow-lg p-8">
        <Link to="/" className="inline-flex items-center text-blue-600 hover:text-blue-800 mb-6">
          <ArrowLeft className="w-4 h-4 mr-2" />
          Volver al inicio
        </Link>
        
        <h1 className="text-3xl font-bold text-gray-900 mb-6">Términos de Servicio</h1>
        <p className="text-gray-600 mb-4">Última actualización: Febrero 2026</p>
        
        <div className="space-y-6 text-gray-700">
          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">1. Aceptación de Términos</h2>
            <p>Al utilizar AI Med Planner, usted acepta estos términos de servicio. Si no está de acuerdo con alguno de estos términos, no utilice nuestros servicios.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">2. Descripción del Servicio</h2>
            <p>AI Med Planner es una plataforma de automatización para clínicas médicas que incluye:</p>
            <ul className="list-disc ml-6 mt-2 space-y-1">
              <li>Asistente de IA para atención al paciente vía WhatsApp</li>
              <li>Gestión automatizada de citas</li>
              <li>Respuestas automáticas en redes sociales</li>
              <li>Recordatorios y seguimiento de pacientes</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">3. Uso Aceptable</h2>
            <p>Usted se compromete a:</p>
            <ul className="list-disc ml-6 mt-2 space-y-1">
              <li>Proporcionar información veraz y actualizada</li>
              <li>No utilizar el servicio para fines ilegales</li>
              <li>No intentar acceder a cuentas de otros usuarios</li>
              <li>Respetar la privacidad de los pacientes</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">4. Privacidad y Datos</h2>
            <p>El tratamiento de sus datos personales se rige por nuestra <Link to="/privacy" className="text-blue-600 hover:underline">Política de Privacidad</Link>.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">5. Limitación de Responsabilidad</h2>
            <p>AI Med Planner es una herramienta de asistencia y no sustituye el juicio médico profesional. No nos hacemos responsables de decisiones médicas basadas únicamente en las interacciones con nuestro asistente de IA.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">6. Modificaciones</h2>
            <p>Nos reservamos el derecho de modificar estos términos en cualquier momento. Los cambios serán efectivos al publicarse en esta página.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">7. Contacto</h2>
            <p>Para consultas sobre estos términos:</p>
            <p className="mt-2"><strong>Email:</strong> legal@aimedplanner.com</p>
          </section>
        </div>
      </div>
    </div>
  );
}
